import { Paper, styled } from '@mui/material'

export const FormsListItemPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  minHeight: 68,
  height: 68,
  cursor: 'pointer',
  '&:hover': { boxShadow: theme.shadows[4] },
}))
